<template>
  <div class="login">
    <div class="dialog">
      <div class="content">
        <img class="logo_login" src="../assets/login_logo.png">
        <input id="mailInput" type="text" placeholder="メールアドレス" v-model="email">
        <input id="passwordInput" type="password" placeholder="パスワード" v-model="password">
        <div id="resetPasswordTextArea">
          <router-link id="resetPasswordText" to="/reset_password">パスワードを忘れた場合</router-link>
        </div>

        <!--
        <div class="loginButton" @click="logIn"><button>ログイン</button></div>
-->

        <button class="loginButton" :class="{disabled: isButtonDisabled}" @click="doLogin">ログイン</button>
      </div>

    </div>

    <div class="loadingBackground" v-if="isLoading">
      <div class="loadingDialog">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          :color="'#ffffff'"
        />
      </div>
    </div>

  </div>
</template>

<script>
  import {db, auth} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'
  import axios from 'axios';


  export default {
    name: 'Login',

    components: {
      HalfCircleSpinner
    },

    data() {
      return {
        email: '',
        password: '',

        companies: [],

        isLoading: false,
      }
    },

    computed: {

      isButtonDisabled() {
        return !(this.email && this.password);
      }
    },

    methods: {

      async doLogin() {
        this.isLoading = true

        /* Firebaseへのログイン */
        let loginData;
        try {
          loginData = await auth.signInWithEmailAndPassword(this.email, this.password)
        } catch (error) {
          // console.log("Error while signInWithEmailAndPassword", error);
          this.isLoading = false
          return
        }

        let uid = loginData.user.uid
        // console.log("userId => ", uid);

        try {
          /* accounts コレクションからこのユーザーのアカウント情報を取得 */
          let querySnapshot = await db.collection('accounts').where('userId', '==', uid).get()

          /* 該当するアカウント情報があれば、その中のcompanyIdを取得 */
          if (querySnapshot.size > 0) {
            let firstDoc = querySnapshot.docs[0]
            // console.log(firstDoc.id, ' => ', firstDoc.data())

            let companyId = firstDoc.data().companyId

            /* companyIdを使ってこのユーザーが実際にadminユーザーかを調べる。adminユーザーであればログインする */
            let adminDataPromise = db.collection('companies').doc(companyId).collection('admins').doc(uid).get()
            let doc = await adminDataPromise

            if (doc.exists) {
              // console.log("Document data:", doc.data());
              this.$store.commit('setCompanyId', companyId)

              //同時にlocal storageにも書き込む
              localStorage.companyId = companyId;

              this.isLoading = false

              this.$router.push('/list')
            } else {
              // doc.data() will be undefined in this case
              // console.log("This user is not admin user (maybe driver or simply not registered to this company)");
            }
          } else {
            // console.log("No such account");
          }
          this.isLoading = false
        } catch (error) {
          // console.log("Error while updating this user's database", error);
        }
      }
    },
    mounted() {
      // console.log("query's email is", this.$route.query.email);

      this.email = this.$route.query.email


      /*
      var bodyFormDataSignin = new FormData();
      bodyFormDataSignin.set('email', 'mika@goldrushcomputing.com');
      bodyFormDataSignin.set('password', 'goldrushdev');

      axios({
        method: 'post',
        url: 'http://ec2-13-231-237-20.ap-northeast-1.compute.amazonaws.com/console/session',
        data: bodyFormDataSignin,
        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });


*/


      /*


     var bodyFormData = new FormData();
     bodyFormData.set('email', 'mika+test7@goldrushcomputing.com');
     bodyFormData.set('operator_type', 'shop');
     bodyFormData.set('shop_id', 'vseYZBNLXGmCx7nDcrF2iA');
     bodyFormData.append('app_ids', '1wku');
     //bodyFormData.append('app_ids', 'abcd');

      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      };

      var token = "823facb4a165c548424f634c893737db913f368b2d38fd8cd12a1580e256f60b"

      axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}

      axios({
        method: 'post',
        url: 'http://ec2-13-231-237-20.ap-northeast-1.compute.amazonaws.com/console/operators',
        data: bodyFormData,
        config: config
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
*/


    },
    firestore: {
      companies: db.collection('companies')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .login {
    /*
    margin-top: 0px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    */

    width: 100%;
    height: 100vh;
  }


  .dialog {

    /* https://stackoverflow.com/a/14816807/1709287 */
    width: 480px;
    height: 600px;

    background-color: white;

    position: absolute; /*it can be fixed too*/
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width: 100%;
    max-height: 100%;
    overflow: auto;

    border-radius: 35px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;


    margin-top: 3%;

  }

  .content {
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: white;
  }

  .logo_login {
    max-width: 50%;
    margin: 50px auto 0 auto;
    position: auto;
    margin-top: 50px;
  }

  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border: 2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }

  #mailInput {
    margin-top: 47px;
  }

  #passwordInput {
    margin-top: 10px;
  }

  #resetPasswordTextArea {
    width: 340px;
    text-align: right;
    margin-top: 0;
  }

  #resetPasswordText {
    color: #9EC002;
    font-size: 14px;
    font-weight: bold;
  }


  .loginButton {
    width: 350px;
    height: 42px;
    background-color: #D2FF00;
    color: #5C5C5C;
    font-size: 18px;
    border-radius: 35px;
    margin-top: 50px;
    outline: none;

    border-style: solid;
    border-color: Transparent;
    border-width: 2px;
  }


  .loginButton:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #C7D931;
  }


  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /*mobile対応*/
  @media (max-width: 768px) {

    .login {
      background-color: #ffffff;

    }

    .dialog {

      /* https://stackoverflow.com/a/14816807/1709287 */
      width: 100%;
      height: 100%;

      background-color: white;

      position: auto; /*it can be fixed too*/
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: 2%;

      /*this to solve "the content will not be cut when the window is smaller than the content": */
      max-width: 90%;
      max-height: 100%;
      overflow: auto;

      border-radius: 35px;
      border-style: solid;
      border-width: 0;

      margin-top: 3%;

    }


    .content {
      width: 100%;
      padding: 5px;
      margin: 5px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      background-color: white;
    }

    .logo_login {
      max-width: 50%;
      margin: 50px auto 0 auto;
      position: auto;
    }

    input {
      width: 260px;
      height: 28px;
      padding: 3px;
      border-style: solid;
      border-width: 2px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border: 2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #mailInput {
      margin-top: 47px;
    }

    #passwordInput {
      margin-top: 10px;
    }

    #resetPasswordTextArea {
      width: 260px;
      text-align: right;
      margin-top: 0;
    }

    #resetPasswordText {
      color: #9EC002;
      font-size: 14px;
      font-weight: bold;
      margin-right: 2%;
    }


    .loginButton {
      width: 150px;
      height: 42px;
      background-color: #D2FF00;
      color: #5C5C5C;
      font-size: 18px;
      border-radius: 35px;
      margin-top: 40px;
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue